import { createRoute } from '@/utils/routing'

export const FIN_CHANNEL_LIST_ROUTE = 'fin-channels'

export function createFinChannelListRoute (options = {}) {
  return createRoute(FIN_CHANNEL_LIST_ROUTE, options)
}
